
import React, { useState } from 'react';
import { FontAwesome } from '@expo/vector-icons';
import { GRAY_BACKGROUND } from '../../config/designSystem/Colors';
import { ParagraphMBold, ParagraphSRegular } from '../../config/designSystem/typography';
import { TouchableOpacity  , View}
  from 'react-native';
import { isWeb } from '../../config/designSystem/Layout';
interface ICollapsableProps{
    onPress?:()=> void
    headerOne?:string;
    contentOne?:string;
}
export const Collapsable =({
  onPress,
  headerOne,
  contentOne,
}: ICollapsableProps)=>{
  const [collapsed, setCollapsed] =useState<boolean>(true);

  const onBtnPress =()=>{
    onPress && onPress();
    setCollapsed(coll=> !coll);
  };

  return( <TouchableOpacity style={{
    borderRadius: 15,
    backgroundColor: GRAY_BACKGROUND,
    padding:20,
    margin:15,
  }}
  onPress={onBtnPress}>
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: '95%',
      }}>
      {isWeb&&<View>
        <ParagraphMBold> {headerOne} </ParagraphMBold>
      </View>}

      {!isWeb&&  <ParagraphMBold>{headerOne} </ParagraphMBold>}

      <FontAwesome name={collapsed ? 'chevron-down' : 'chevron-up'} />
    </View>
    {!collapsed && (
      <View style={{ marginTop: 10 }}>
        <ParagraphSRegular >{contentOne}</ParagraphSRegular>
      </View>)
    }
  </TouchableOpacity>
  );
};


